/* ==========================================================================
   EL BENDECIDO V2 — enhancement script
   Vanilla, no dependencies, no framework, no animation library.

   Everything here is an ENHANCEMENT. If this file fails to load, the page
   stays fully usable: the pricing list shows every vehicle price stacked,
   and the mobile menu falls back to a details/summary disclosure.

   NOTE ON LAYOUT STABILITY
   `document.documentElement.classList.add('elb-js')` must run in a tiny
   inline <script> in <head>, NOT here. If it runs after first paint the
   pricing list renders all four vehicle rows and then collapses to one,
   which is a visible layout shift and counts against CLS.
   ========================================================================== */
(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     VEHICLE-SIZE PRICING SELECTOR
     Filters the price rows to the chosen vehicle class.
     ---------------------------------------------------------------------- */
  function initPricing(root) {
    var inputs = root.querySelectorAll('.elb-segment__input');
    var announce = root.querySelector('[data-elb-announce]');
    if (!inputs.length) return;

    function apply(vehicleId, announceChange) {
      var rows = root.querySelectorAll('[data-elb-vehicle]');
      for (var i = 0; i < rows.length; i++) {
        var match = rows[i].getAttribute('data-elb-vehicle') === vehicleId;
        // `hidden` removes the row from the accessibility tree as well as
        // from view, so screen readers and sighted users see the same set.
        if (match) {
          rows[i].removeAttribute('hidden');
        } else {
          rows[i].setAttribute('hidden', '');
        }
      }

      if (announceChange && announce) {
        var label = root.querySelector('label[for="elb-vehicle-' + vehicleId + '"]');
        var name = label ? label.textContent.trim() : vehicleId;
        // Re-assigning textContent on an aria-live region is what triggers
        // the announcement.
        announce.textContent =
          (announce.getAttribute('data-elb-announce-template') || 'Showing prices for {vehicle}')
            .replace('{vehicle}', name);
      }

      // Analytics: emit only on a real user selection. `announceChange` is
      // false on the initial apply() call, so page load never emits.
      // The raw id (sedan/midsuv/fullsuv/pickup) is normalised by the bridge;
      // an unrecognised value is dropped there rather than published.
      if (announceChange) {
        document.dispatchEvent(
          new CustomEvent('elb:analytics', {
            detail: {
              event: 'vehicle_class_select',
              path: window.location.pathname,
              language: document.documentElement.lang || 'en',
              vehicle_class: vehicleId,
              component_name: 'pricing_selector',
              action_location: 'pricing_selector'
            }
          })
        );
      }
    }

    for (var i = 0; i < inputs.length; i++) {
      inputs[i].addEventListener('change', function (e) {
        if (e.target.checked) apply(e.target.value, true);
      });
    }

    var checked = root.querySelector('.elb-segment__input:checked') || inputs[0];
    checked.checked = true;
    apply(checked.value, false);
  }

  /* ----------------------------------------------------------------------
     MOBILE MENU
     Focus trapping, Escape to close, scroll lock, focus restoration.
     ---------------------------------------------------------------------- */
  function initMenu(root) {
    var toggle = root.querySelector('[data-elb-menu-toggle]');
    var panel = root.querySelector('[data-elb-menu-panel]');
    if (!toggle || !panel) return;

    var lastFocused = null;
    var mobile = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    var FOCUSABLE =
      'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';

    function open() {
      lastFocused = document.activeElement;
      panel.removeAttribute('hidden');
      toggle.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('elb-scroll-locked');
      var first = panel.querySelector(FOCUSABLE);
      if (first) first.focus();
      document.addEventListener('keydown', onKeydown, true);
    }

    function close(restoreFocus) {
      panel.setAttribute('hidden', '');
      toggle.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('elb-scroll-locked');
      document.removeEventListener('keydown', onKeydown, true);
      if (restoreFocus !== false && lastFocused) lastFocused.focus();
    }

    function onKeydown(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        close(true);
        return;
      }
      if (e.key !== 'Tab') return;

      // Keep Tab inside the open panel.
      var items = panel.querySelectorAll(FOCUSABLE);
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }

    toggle.addEventListener('click', function () {
      if (mobile && !mobile.matches) return;
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      if (expanded) { close(true); } else { open(); }
    });

    // Close when a destination is chosen.
    panel.addEventListener('click', function (e) {
      if (e.target.closest('a')) close(false);
    });

    function syncViewport() {
      if (!mobile || mobile.matches) {
        close(false);
      } else {
        panel.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('elb-scroll-locked');
        document.removeEventListener('keydown', onKeydown, true);
      }
    }

    if (mobile && typeof mobile.addEventListener === 'function') {
      mobile.addEventListener('change', syncViewport);
    } else if (mobile && typeof mobile.addListener === 'function') {
      mobile.addListener(syncViewport);
    }
    syncViewport();
  }

  function boot() {
    var pricing = document.querySelectorAll('[data-elb-pricing]');
    for (var i = 0; i < pricing.length; i++) initPricing(pricing[i]);

    var headers = document.querySelectorAll('[data-elb-header]');
    for (var j = 0; j < headers.length; j++) initMenu(headers[j]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
